/// <amd-module name="Analytics/Shared/Common/Definitions" />
import * as Resources from "Analytics/Shared/Common/Resources";
import { IConfigurationProps, Period } from "Analytics/Shared/Common/Types";
import { format } from "VSS/Core/Util/String";

export abstract class ConfigurationProps implements IConfigurationProps {
    public get options() {
        return this._options;
    }

    protected _options: { [key: number]: string };

    constructor(initParam?: any) {
        this._options = [];
        this._initializeOptions(initParam);
    }

    protected abstract _initializeOptions(initParam?: any): void;
}

export class PeriodConfigurationProps extends ConfigurationProps {
    public constructor(maxPeriod: Period) {
        super(maxPeriod);
    }

    protected _initializeOptions(maxPeriod: Period) {
        maxPeriod = maxPeriod || Period.Days_30;
        this._options[Period.Days_7] = format(Resources.NoOfDaysFormatString, Resources.SevenNumberText);
        if (maxPeriod > Period.Days_7) {
            this._options[Period.Days_14] = format(Resources.NoOfDaysFormatString, Resources.FourteenNumberText);
        }

        if (maxPeriod > Period.Days_14) {
            this._options[Period.Days_30] = format(Resources.NoOfDaysFormatString, Resources.ThirtyDays);
        }

        if (maxPeriod > Period.Days_30) {
            this._options[Period.Days_180] = format(Resources.NoOfDaysFormatString, Resources.OneEightyDays);
        }
    }
}
